import React from "react";
import { Button } from '@mui/material';
import { DialogContent, Dialog, DialogTitle, DialogActions, DialogContentText, Slide, Typography } from '@mui/material';
import { CheckCircle as SuccessIcon } from '@mui/icons-material'
import { STAKEHOLDER_SIGN_UP_URL } from "../URLs";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const PreRegPopover = (props) => {
    return (
        <Dialog maxWidth='xs' fullWidth open={props.onOpen} TransitionComponent={Transition}>
            <DialogTitle sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <SuccessIcon sx={{ fontSize: 60, color: "#64dd17", marginBottom: "2vh" }}/>
                <Typography variant="h6" >{props.urn}</Typography>
                <Typography variant="subtitle1" >{props.message}</Typography> 
             </DialogTitle>
            
            <DialogContent />
            <DialogActions>
                <Button onClick={() => { props.navigate(props.navigatePath) }} >Go to home page</Button>
                </DialogActions>
        </Dialog>
    );
};
